const chips = document.querySelectorAll(".chip");

chips.forEach((chip) => {
	chip.onclick = function() {
		//alert('click');
		chip.classList.toggle('active');
	}
});
